import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { CheckCircle2, Loader2 } from 'lucide-react';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AdvertiseSuccessPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading');
  const sessionId = searchParams.get('session_id');
  const adId = searchParams.get('ad_id');

  useEffect(() => {
    const checkPayment = async () => {
      if (!sessionId) {
        setStatus('error');
        return;
      }

      try {
        const response = await axios.get(`${API_URL}/advertisements/payment-status/${sessionId}`);
        if (response.data.payment_status === 'paid') {
          setStatus('success');
        } else {
          // Poll again after 2 seconds
          setTimeout(checkPayment, 2000);
        }
      } catch (error) {
        setStatus('error');
      }
    };

    checkPayment();
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-cream-100 flex items-center justify-center py-12 px-4" data-testid="advertise-success-page">
      <Card className="max-w-md w-full">
        <CardContent className="p-8 text-center">
          {status === 'loading' && (
            <>
              <Loader2 className="w-16 h-16 text-saffron-500 mx-auto mb-4 animate-spin" />
              <h2 className="font-heading text-2xl font-bold text-gray-900 mb-2">
                Processing Payment...
              </h2>
              <p className="text-gray-600">Please wait while we confirm your payment.</p>
            </>
          )}

          {status === 'success' && (
            <>
              <CheckCircle2 className="w-16 h-16 text-green-500 mx-auto mb-4" />
              <h2 className="font-heading text-2xl font-bold text-gray-900 mb-2">
                Payment Successful!
              </h2>
              <p className="text-gray-600 mb-6">
                Thank you! Your listing is now live and visible in the directory.
              </p>
              <div className="space-y-3">
                <Button onClick={() => navigate('/directory')} className="w-full btn-primary">
                  View Directory
                </Button>
                <Button onClick={() => navigate('/advertise')} variant="outline" className="w-full btn-outline">
                  Create Another Listing
                </Button>
              </div>
            </>
          )}

          {status === 'error' && (
            <>
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-3xl">⚠️</span>
              </div>
              <h2 className="font-heading text-2xl font-bold text-gray-900 mb-2">
                Payment Issue
              </h2>
              <p className="text-gray-600 mb-6">
                There was an issue processing your payment. Please contact us at Khalsasidak13@gmail.com
              </p>
              <Button onClick={() => navigate('/advertise')} className="w-full btn-primary">
                Try Again
              </Button>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default AdvertiseSuccessPage;
